import { HttpClient } from 'api/http-client';
const NAMESPACE = '/templates';
class DocumentTemplatesHttpClient extends HttpClient {
    findAll() {
        return this.get(`${NAMESPACE}/documents`);
    }
    embed(url) {
        return this.get(`${NAMESPACE}/get-iframely-response?url=${url}`);
    }
}
export const DocumentTemplatesAPI = new DocumentTemplatesHttpClient();
